import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/services/rebar-detailing',
		name: 'rebarDetailing',
		component: () =>
			import(
				/* webpackChunkName: "rebarDetailing" */ '../views/services/RebarDetailing.vue'
			)
	},
	{
		path: '/services/rebar-estimation',
		name: 'rebarEstimation',
		component: () =>
			import(
				/* webpackChunkName: "rebarEstimation" */ '../views/services/RebarEstimation.vue'
			)
	},
	{
		path: '/services/structural-design',
		name: 'structuralDesign',
		component: () =>
			import(
				/* webpackChunkName: "structuralDesign" */ '../views/services/StructuralDesign.vue'
			)
	},
	{
		path: '/services/precast-design-and-detailing',
		name: 'precastDesignDetailing',
		component: () =>
			import(
				/* webpackChunkName: "PrecastDesignDetailing" */ '../views/services/PrecastDesignDetailing.vue'
			)
	},
	{
		path: '/services/software-development',
		name: 'softwareDevelopment',
		component: () =>
			import(
				/* webpackChunkName: "softwareDevelopment" */ '../views/services/SoftwareDevelopment.vue'
			)
	},
	{
		path: '/qualityandvalue',
		name: 'qualityandvalue',
		component: () =>
			import(
				/* webpackChunkName: "QualityValue" */ '../views/QualityValue.vue'
			)
	},
	{
		path: '/projects/rebar-detailing',
		name: 'rebarProject',
		component: () =>
			import(
				/* webpackChunkName: "Projects" */ '../views/projects/RebarDetailing.vue'
			)
	},
	{
		path: '/projects/structural-design',
		name: 'structuralDesignProject',
		component: () =>
			import(
				/* webpackChunkName: "Projects" */ '../views/projects/StructuralDesign.vue'
			)
	},
	{
		path: '/projects/software-development',
		name: 'softwareDevelopmentProject',
		component: () =>
			import(
				/* webpackChunkName: "Projects" */ '../views/projects/SoftwareDevelopment.vue'
			)
	},
	{
		path: '/careers',
		name: 'careers',
		component: () =>
			import(/* webpackChunkName: "Careers" */ '../views/Careers.vue')
	},
	{
		path: '/contactus',
		name: 'contactus',
		component: () =>
			import(/* webpackChunkName: "Contactus" */ '../views/Contactus.vue')
	}
];

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0, behavior: 'auto' };
	}
});

export default router;
